module.exports = __webpack_public_path__ + "media/images/expert__fohan-djourou-c8c3bf36edcdf4682772ae1f8e3f0771.png";